import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { DECLARATIONS_NEW_QUERY_KEYS } from './overviewQuery';

const REFRESH_AFTER_MS = 30_000;
const SETTLE_MS = 2_000;

export const useDeclarationsFreshness = () => {
	const queryClient = useQueryClient();
	useEffect(() => {
		let handledAt = 0;
		const onReturn = () => {
			if (document.visibilityState !== 'visible' || Date.now() - handledAt < SETTLE_MS) return;
			const updatedAt = queryClient.getQueryState(DECLARATIONS_NEW_QUERY_KEYS.overview)?.dataUpdatedAt;
			if (!updatedAt || Date.now() - updatedAt < REFRESH_AFTER_MS) return;
			handledAt = Date.now();
			void queryClient.invalidateQueries({ queryKey: DECLARATIONS_NEW_QUERY_KEYS.all });
		};
		document.addEventListener('visibilitychange', onReturn);
		window.addEventListener('focus', onReturn);
		window.addEventListener('online', onReturn);
		window.addEventListener('pageshow', onReturn);
		return () => {
			document.removeEventListener('visibilitychange', onReturn);
			window.removeEventListener('focus', onReturn);
			window.removeEventListener('online', onReturn);
			window.removeEventListener('pageshow', onReturn);
		};
	}, [queryClient]);
};
